import { compose, pure } from 'recompose'
import { connect } from 'react-redux'

import { provideDocStatus } from '@slite/editor'
import { getConnectionStatus } from 'data/ui/selectors'
import { selectors as NotesSelectors } from 'data/notes'
import { track } from 'data/analytics/actions'

export default compose(
  pure,
  connect(
    (state, { noteId }) => {
      const note = NotesSelectors.getNote(state, noteId)
      return {
        note,
        collabConnectionStatus: getConnectionStatus(state, 'collab'),
      }
    },
    {
      track,
    }
  ),
  provideDocStatus()
)
